import type { SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";
import {
  EVAL_RUN_TERMINAL_STATUSES,
  type EvalRunResponse,
} from "~/pages/manifold-nextgen/types/eval-run";

const { VITE_CONVERSATIONS_API } = import.meta.env;

// Bounded cadence while a run is in flight. The launch UI shows lifecycle state
// only (no report), so this is the sole "still going" signal we poll.
const POLL_INTERVAL_MS = 3000;

// Polls a single eval run by id, independent of any active agent turn (SWR
// refreshes regardless of run state, since the run executes on a Fargate task
// that outlives the turn). Refreshes on a bounded interval while the run is
// non-terminal and stops once it reaches succeeded/failed. A `null` id skips the
// request entirely — nothing is focused.
export const useEvalRunStatus = (runId: string | null): SWRResponse<EvalRunResponse> =>
  useFetcher<EvalRunResponse>(runId ? `${VITE_CONVERSATIONS_API}/eval-runs/${runId}` : null, {
    refreshInterval: (latest?: EvalRunResponse) =>
      latest && EVAL_RUN_TERMINAL_STATUSES.has(latest.status) ? 0 : POLL_INTERVAL_MS,
  });
